import React, { useCallback } from 'react';
import { Grid } from '@material-ui/core';
import { PickerComponent, ComponentController } from 'components/common';
import { PayeeFormNames } from './Helpers';

const StateLookup = ({
  stateFieldName, payeeDetailsState, setPayeeDetailsState, abortController,
  setAbortController, control, forceClearDatasourceState, setForceClearDatasourceState,
  errors, getRequiredError, setBannerState, setValue, resetField, setLoading
}) => {
  const onStateChange = useCallback(
    (value, name) => {
      resetField('payee');

      setForceClearDatasourceState({
        "payee": true,
      });
      setPayeeDetailsState((previous) => {
        return {
          ...previous,
          payee: '',
          payeeDetails: null,
          orbisId: '',
          hamiltonId: '',
          source: '',
          givenName: '',
          familyName: '',
          [name]: value?.subdivisionName,
          [`${name}Code`]: value?.subdivisionCode,
        };
      });
      abortController.abort();
    },
    [setPayeeDetailsState, abortController],
  );

  const setLookupData = useCallback((setRows, filter) => {
    const filteredItems = payeeDetailsState.subdivisions.filter(item =>
      item.subdivisionName.toLowerCase().startsWith(filter.toLowerCase()) ||
      item.subdivisionCode.slice(-2).toLowerCase().startsWith(filter.toLowerCase()) 
    );
    setRows(filteredItems);
  }, [payeeDetailsState.subdivisions]);

  const renderStateLookup = () => {
    const name = stateFieldName;
    return (
      <Grid item>
        <ComponentController
          name={name}
          control={control}
          required={true}
          render={({ field: { name, onBlur, onChange } }) => (
            <PickerComponent
              label={PayeeFormNames[name]}
              fieldName={name}
              value={payeeDetailsState[name]}
              config={{ showAddOptionIfNoData: false }}
              setLookupData={setLookupData}
              forceClearDatasource={forceClearDatasourceState}
              abortController={abortController}
              error={!!errors[name]}
              errorText={getRequiredError(name, PayeeFormNames[name])}
              setBannerState={setBannerState}
              setValidationValue={setValue}
              setLoading={setLoading}
              setFormState={setPayeeDetailsState}
              setAbortController={setAbortController}
              onChange={(value) => {
                onStateChange(value, name);
                onChange(value);
              }}
              onBlur={onBlur}
              OptionsHeader={({ className }) => {
                return (
                  <Grid container direction="row" spacing={0} className={className}>
                    <Grid item xs={9}><div>State</div></Grid>
                    <Grid item xs={3}><div>State Code</div></Grid>
                  </Grid>
                );
              }}
              OptionView={({ option, className }) => {
                return (
                  <Grid container direction="row" spacing={0} className={className}>
                    <Grid item xs={9}><div>{option.subdivisionName}</div></Grid>
                    <Grid item xs={3}><div>{option.subdivisionCode}</div></Grid>
                  </Grid>
                );
              }}
            />
          )}
        />
      </Grid>
    );
  };

  return (
    <>{renderStateLookup()}</>
  );
}

export default StateLookup;
